import type { ReactNode } from "react";

/** Scrolling page content with the curation chat docked on the right. */
export const CurationWorkspaceLayout = ({
  children,
  chat,
}: {
  children: ReactNode;
  chat: ReactNode;
}) => (
  <div className="flex h-full min-h-0 flex-1 overflow-hidden">
    <div className="min-h-0 min-w-0 flex-1 overflow-y-auto">{children}</div>
    {chat}
  </div>
);
